export const getCoverKey = (title: string, length: number): number => {
  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash += title.charCodeAt(i);
  }

  return Math.floor(hash % length);
};
